import { createFileRoute, notFound } from '@tanstack/react-router';
import { doNothing } from 'remeda';

import config from '@@config';
import { textSearchParams } from '@@containers/Search/unitySearchParams';
import { requireRoles } from '@@router/guards';
import { getContentLocale } from '@@scripts/store/settings/useSettingsStore';

import { kickwordListQuery } from './-components/kickwordListQuery';
import { Layout } from './-components/Layout';

const requireKickwordRoles = requireRoles(config.navigation.kickwords.authorize);

export const Route = createFileRoute('/_authenticated/kickwords')({
    validateSearch: textSearchParams,
    // A new search makes a new match, which runs the loader again
    loaderDeps: ({ search }) => textSearchParams.parse(search),
    beforeLoad: ({ search }) => {
        requireKickwordRoles();

        // Hidden from users until we confirm nobody needs them, then removed
        throw notFound();

        const contentLocale = getContentLocale();

        // Built on every load, so the options follow the content language as well as the search
        return { kickwordsQuery: kickwordListQuery(search.q, contentLocale) };
    },
    loader: ({ context }) => {
        context.queryClient.infiniteQuery(context.kickwordsQuery).catch(doNothing());
    },
    component: Layout,
});
